import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NebulaDatePipe } from './nebula-date.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [NebulaDatePipe],
  exports: [NebulaDatePipe]
})
export class NebulaDateModule { }
